<template>
  <v-form v-model="settings.occupancy.form" ref="addOccupancyRuleForm" lazy-validation
          style="width: 100%;">
    <v-layout wrap v-if="room !== undefined">
      <v-flex xs3>
        <v-text-field
          v-model="settings.occupancy.rule.occupancy"
          label="Belegung"
          required
          type="number"
          :rules="rules"
        ></v-text-field>
      </v-flex>
      <v-flex xs3 offset-xs1>
        <v-text-field
          v-model="settings.occupancy.rule.payment"
          :label="getOccupancyValueLabel(room.occupancyPaymentMode)"
          required
          type="number"
          :rules="rules"
        />
      </v-flex>
      <v-flex xs3 offset-xs2 class="text-sm-right">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon text v-on="on"
                   :disabled="room.stdOccupancy === undefined || room.minOccupancy === undefined || room.maxOccupancy === undefined"
                   @click="addOccupancyRules()" color="primary">
              <v-icon>add</v-icon>
            </v-btn>
          </template>
          <span>Belegungsregelung hinzufügen</span>
        </v-tooltip>
      </v-flex>
      <v-flex class="text-sm-right" style="color: red;" xs12 sm8 offset-sm4
              v-if="room.stdOccupancy === undefined || room.minOccupancy === undefined || room.maxOccupancy === undefined">
        Definieren Sie vorerst die Zimmerbelegungen!
      </v-flex>
      <v-flex class="text-sm-right" style="color: red;" xs12 sm8 offset-sm4 v-else>
        <span v-if="settings.occupancy.rule.occupancy === room.stdOccupancy">
          Standardbelegung muss nicht definiert werden!
        </span>
        <span v-else-if="settings.occupancy.rule.occupancy < room.minOccupancy">
          Belegung kann nicht kleiner sein als Mindestbelegung!
        </span>
        <span v-else-if="settings.occupancy.rule.occupancy > room.maxOccupancy">
          Belegung kann nicht größer sein als Maximalbelegung!
        </span>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
  export default {
    name: 'AddOccupancyRule',
    props: {
      room: undefined
    },
    data() {
      return {
        settings: {
          occupancy: {
            form: undefined,
            rule: {
              occupancy: undefined,
              payment: undefined
            }
          }
        },
        rules: [
          v => !!v || this.$i18n.t('form.required'),
        ],
      };
    },
    methods: {
      addOccupancyRules() {
        if (this.room.occupancyPaymentMode === undefined) {
          this.room.occupancyPaymentMode = 'PERCENT';
        }

        if (this.$refs.addOccupancyRuleForm.validate()
          && this.settings.occupancy.rule.occupancy !== this.room.stdOccupancy
          && this.settings.occupancy.rule.occupancy >= this.room.minOccupancy
          && this.settings.occupancy.rule.occupancy <= this.room.maxOccupancy) {
          this.room.occupancyRules.push(JSON.parse(JSON.stringify(this.settings.occupancy.rule)));
          this.settings.occupancy.rule = {
            occupancy: undefined,
            payment: undefined
          };
          this.$refs.addOccupancyRuleForm.reset();
        }
      },
      getOccupancyValueLabel(mode) {
        return mode === 'EURO' ? 'Preis' : 'Prozent';
      }
    }
  };
</script>
